import {
  Alpine,
  Livewire
} from '../../../../vendor/livewire/livewire/dist/livewire.esm.js';

import Collapse from '@alpinejs/collapse';
import Focus from '@alpinejs/focus';
import Intersect from '@alpinejs/intersect';
import Resize from '@alpinejs/resize';

Alpine.plugin(Collapse);
Alpine.plugin(Intersect);
Alpine.plugin(Focus);
Alpine.plugin(Resize);

/**
 * Custom Plugins
 */
import videoIframePlayers from './_video-iframe-players';
import emerge from './_emerge';
import { default as header } from './_header';
import { default as mediaModal } from './_media-modal';

Alpine.store('header', header);
Alpine.store('media-modal', mediaModal);

/**
 * Reusable Data Objects
 */
import slider from './_slider';
import studentSlider from './_student-slider';

Alpine.plugin(emerge);
Alpine.plugin(videoIframePlayers);

Alpine.data('slider', slider);
Alpine.data('studentSlider', studentSlider);

/**
 * Livewire Hooks
 */
import animateMove from './_animate-move';
import fadeIn from './_fade-in';

Livewire.hook('commit', animateMove);
Livewire.hook('morph.added', fadeIn);

export const livewire = Livewire;
